// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../actions-list';
import {getMetrics} from '../../../pip/shared/repositories';
import {selectMetric} from './select-metric';

export const readMetrics = () =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const metrics = await getMetrics();

            dispatch({
                metrics,
                type: actions.UPDATE_OPEN_PIP_PROGRAMS_REPORT_METRICS
            });

            const index = metrics.findIndex(metric => metric.key === 'Y');

            if (index > 0) {

                selectMetric(index, metrics);

            }

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/action-creators/read-metrics.js